import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';

function initialize(testmonialsElement) {
    const swiperPagination = testmonialsElement.querySelector('.swiper-pagination');
    const progressBar = testmonialsElement.querySelector('.swiper-pagination');
    const slidesCount = testmonialsElement.querySelectorAll('.swiper-slide').length;
    const hasMultipleSlides = slidesCount > 1;

    new Swiper(testmonialsElement.querySelector('.swiper'), {
        modules: hasMultipleSlides ? [Pagination, Navigation, Autoplay] : [],
        slidesPerView: 1,
        loop: hasMultipleSlides,
        spaceBetween: 20,

        breakpoints: {
            320: {
                spaceBetween: 20,
            },
        },

        autoplay: hasMultipleSlides
            ? {
                  delay: 15000,
                  disableOnInteraction: false,
              }
            : false,

        navigation: hasMultipleSlides
            ? {
                  nextEl: testmonialsElement.querySelector('.btn-next'),
                  prevEl: testmonialsElement.querySelector('.btn-prev'),
              }
            : false,

        pagination: hasMultipleSlides
            ? {
                  el: swiperPagination,
                  clickable: true,
                  renderBullet: function (index, className) {
                      return (
                          '<span class="swiper-pagination-bullet">' +
                          ' <span>' +
                          (index + 1).toString().padStart(2, '0') +
                          '</span>' +
                          ' <div class="progress"><span class="progress-bar"></span></div> ' +
                          '</span>'
                      );
                  },
              }
            : false,
        on: {
            autoplayTimeLeft(s, time, progress) {
                if (!progressBar) {
                    return;
                }
                progressBar.style.setProperty('--progress', 1 - progress);
            },
        },
    });
}

function initializeAll() {
    document.querySelectorAll('.testmonials').forEach(function (element) {
        initialize(element);
    });
}

initializeAll();
